import { useAuth } from "../context/auth";

export default function useSellerId() {
    return useAuth()?.user?.seller_id ?? null;
}
